import type { Atom } from "../types/Atom"
import { BigIntToUint8 } from "./BigIntToUint8"
import { BooleanToUint8 } from "./BooleanToUint8"
import { NumberToUint8 } from "./NumberToUint8"
import { StringToUInt8 } from "./StringToUInt8"

export function AtomToUint8(value: Atom): Uint8Array {
  switch (typeof value) {
    case "bigint":
      return BigIntToUint8(value)
    case "boolean":
      return BooleanToUint8(value)
    case "number":
      return NumberToUint8(value)
    case "string":
      return StringToUInt8(value)
  }
}
